import { Injectable } from '@angular/core';
import { isStringNullOrEmpty } from '@wz-utilities/string.utilities';
import { DocumentModels } from 'models/document.models';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { HttpModels } from '../../../../models/api/http.models';
import { FileApiService } from './api/file-api.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private fileApiService: FileApiService) {}

  getFileSasUrl(
    arg: number | DocumentModels.Fragment2,
  ): Observable<string | any> {
    if (typeof arg === 'number') {
      return this.fileApiService.getFileInformations(arg).pipe(
        map((info: HttpModels.BlobInfoResponse) => {
          if (info) {
            return info.blobReadOnlyPath;
          }

          return null;
        }),
      );
    } else {
      return this.fileApiService
        .getFileSasUrlByDownloadKey(arg.downloadKey)
        .pipe(map((res) => res.blobReadOnlyPath));
    }
  }

  downloadFragment(fragment: DocumentModels.Fragment2) {
    return this.getFileSasUrl(fragment).pipe(
      mergeMap((res) => {
        return this.fileApiService.getFileFromBlobStorage(res);
      }),
      map((blob) => {
        this.saveBlob(blob, fragment.fileName);
        return blob;
      }),
    );
  }

  openFileNewTab(id: number): Observable<void> {
    return this.getFileSasUrl(id).pipe(
      map((res) => {
        window.open(res, '_blank');
      }),
    );
  }

  /**
   * Downloads a file from blobstorage, using File database table
   * @param id file id
   * @param fallbackFileName a fallback file name to handle no Content-Disposition header
   */
  downloadFile(
    id: number,
    fallbackFileName?: string,
  ): Observable<HttpModels.HttpFileResponse> {
    return this.fileApiService.downloadBlobFromStorageByFileId(id).pipe(
      map((res) => {
        if (isStringNullOrEmpty(res.fileName)) {
          res.fileName = fallbackFileName!;
        }

        this.saveBlob(res);
        return res;
      }),
    );
  }

  downloadDocByGammeName(
    gammeName: string,
    docName: string,
  ): Observable<HttpModels.HttpFileResponse> {
    const url: string = `/GetDocByGammeName?GammeName=${gammeName}&docName=${docName}`;
    return this.fileApiService.getFileAsBlob(url);
  }

  public saveBlob(
    fileResponse: HttpModels.HttpFileResponse,
    fallbackFileName?: string,
  ) {
    if (fallbackFileName) {
      fileResponse.fileName = fallbackFileName;
    }
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(
        fileResponse.blob,
        fileResponse.fileName,
      );
    } else {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      let url = window.URL.createObjectURL(fileResponse.blob);
      a.href = url;
      a.download = fileResponse.fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  OpenFileinNewTab(data: Blob): void {
    const blob = new Blob([data], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const newTab = window.open('', '_blank'); // Ouvre immédiatement un onglet vide

    if (newTab) {
      newTab.location.href = blobUrl; // Injecte le PDF une fois prêt
    } else {
      console.error('Le navigateur a bloqué l’ouverture du nouvel onglet.');
    }
  }
}
